import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Mail, MapPin } from "lucide-react";
import { api } from "../lib/api";
import { Reveal } from "../components/Reveal";

const field = "w-full border border-border bg-background px-4 py-3 font-body text-sm focus:outline-none focus:border-foreground transition-colors";

export default function Contact() {
  const [wa, setWa] = useState("");
  const [numbers, setNumbers] = useState([]);
  const [store, setStore] = useState({ email: "", address: "" });
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  useEffect(() => { api.get("/config").then((r) => { setWa(r.data.whatsapp); setNumbers(r.data.whatsapp_numbers || []); setStore({ email: r.data.store_email || "", address: r.data.store_address || "" }); }).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Please fill all fields"); return; }
    try { await api.post("/contact", form); setSent(true); toast.success("Message sent!"); setForm({ name: "", email: "", message: "" }); }
    catch { toast.error("Could not send message"); }
  };

  return (
    <div className="pt-32 pb-28 max-w-[1600px] mx-auto px-6 md:px-12">
      <Reveal>
        <p className="overline text-[hsl(var(--primary))] mb-6">Get in touch</p>
        <h1 className="font-display text-5xl md:text-7xl">Let's talk shirts.</h1>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-16 mt-16">
        <Reveal>
          <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
            <input className={field} placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
            <input className={field} placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
            <textarea className={`${field} h-40 resize-none`} placeholder="Your message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
            <button type="submit" data-testid="contact-submit" className="bg-[hsl(var(--primary))] text-white px-8 py-4 font-body text-sm hover:bg-[hsl(var(--secondary))] transition-colors">
              {sent ? "Sent ✓" : "Send message"}
            </button>
          </form>
        </Reveal>
        <Reveal delay={0.1} className="space-y-8">
          {numbers.length > 0 && (
            <div className="flex items-start gap-4" data-testid="contact-whatsapp">
              <span className="w-12 h-12 border border-border flex items-center justify-center shrink-0"><MessageCircle className="w-5 h-5" strokeWidth={1.5} /></span>
              <div>
                <p className="overline text-muted-foreground">Order / Call on WhatsApp</p>
                <div className="flex flex-col gap-1 mt-1">
                  {numbers.map((n) => (
                    <a key={n} href={`https://wa.me/${n}`} target="_blank" rel="noreferrer" data-testid={`wa-${n}`}
                      className="font-display text-2xl hover:text-[hsl(var(--primary))] transition-colors leading-tight">
                      +{n.slice(0, 2)} {n.slice(2)}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          )}
          <div className="flex items-start gap-4">
            <span className="w-12 h-12 border border-border flex items-center justify-center shrink-0"><Mail className="w-5 h-5" strokeWidth={1.5} /></span>
            <div><p className="overline text-muted-foreground">Email</p><a href={`mailto:${store.email}`} className="font-display text-2xl link-underline" data-testid="contact-email-display">{store.email}</a></div>
          </div>
          <div className="flex items-start gap-4">
            <span className="w-12 h-12 border border-border flex items-center justify-center shrink-0"><MapPin className="w-5 h-5" strokeWidth={1.5} /></span>
            <div><p className="overline text-muted-foreground">Studio</p><p className="font-display text-2xl whitespace-pre-line" data-testid="contact-address-display">{store.address}</p></div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
